<template>
  <section class="da-kpis">
    <h2 class="da-kpis__title">
      Resumo do período
    </h2>
    <p class="da-kpis__lead">
      Indicadores calculados após aplicar o período abaixo.
    </p>

    <div
      v-if="loading"
      class="da-kpis__loading"
    >
      <b-spinner type="grow" />
    </div>
    <template v-else>
      <div class="da-kpis__top-row">
        <article
          v-if="cardConversas"
          class="da-kpi-card da-kpi-card--featured da-kpi-card--enter"
          :style="{ animationDelay: '0ms' }"
        >
          <div
            v-if="cardConversas.icon"
            class="da-kpi-card__icon"
          >
            <feather-icon
              :icon="cardConversas.icon"
              size="26"
            />
          </div>
          <span class="da-kpi-card__label">{{ cardConversas.label }}</span>
          <p class="da-kpi-card__value">
            {{ cardConversas.value }}
          </p>
          <p
            v-if="cardConversas.subtitle"
            class="da-kpi-card__sub"
          >
            {{ cardConversas.subtitle }}
          </p>
          <p
            v-if="cardConversas.delta != null && cardConversas.delta !== ''"
            class="da-kpi-card__delta"
            :class="{
              'da-kpi-card__delta--up': cardConversas.deltaPositive === true,
              'da-kpi-card__delta--down': cardConversas.deltaPositive === false,
              'da-kpi-card__delta--neu': cardConversas.deltaPositive == null,
            }"
          >
            {{ cardConversas.delta }}
          </p>
        </article>

        <div
          v-if="cardFinalizados"
          class="da-kpi-finalizados-wrap"
        >
          <article
            class="da-kpi-card da-kpi-card--clickable da-kpi-card--enter"
            :class="{ 'da-kpi-card--expanded': finalizadosExpandido }"
            :style="{ animationDelay: '45ms' }"
            role="button"
            tabindex="0"
            :aria-expanded="finalizadosExpandido ? 'true' : 'false'"
            aria-controls="da-kpi-finalizados-detalhe"
            @click="alternarFinalizados"
            @keydown.enter.prevent="alternarFinalizados"
            @keydown.space.prevent="alternarFinalizados"
          >
            <feather-icon
              icon="ChevronDownIcon"
              size="22"
              class="da-kpi-card__chev"
            />
            <span class="da-kpi-card__label">{{ cardFinalizados.label }}</span>
            <p class="da-kpi-card__value">
              {{ cardFinalizados.value }}
            </p>
            <p
              v-if="cardFinalizados.subtitle"
              class="da-kpi-card__sub"
            >
              {{ cardFinalizados.subtitle }}
            </p>
            <p
              v-if="cardFinalizados.delta != null && cardFinalizados.delta !== ''"
              class="da-kpi-card__delta"
              :class="{
                'da-kpi-card__delta--up': cardFinalizados.deltaPositive === true,
                'da-kpi-card__delta--down': cardFinalizados.deltaPositive === false,
                'da-kpi-card__delta--neu': cardFinalizados.deltaPositive == null,
              }"
            >
              {{ cardFinalizados.delta }}
            </p>
          </article>

          <div
            id="da-kpi-finalizados-detalhe"
            class="da-kpi-finalizados__panel"
            :class="{ 'da-kpi-finalizados__panel--open': finalizadosExpandido }"
            role="region"
            :aria-hidden="finalizadosExpandido ? 'false' : 'true'"
            @click.stop
          >
            <div class="da-kpi-finalizados__inner">
              <p class="da-kpi-finalizados__lead">
                Contagem por origem (status resolvido):
              </p>
              <ul class="da-kpi-finalizados__list">
                <li>
                  <span class="da-kpi-finalizados__lbl">Sem atendente vinculado</span>
                  <span class="da-kpi-finalizados__num">{{ detalheSeguro.semAtendenteVinculado }}</span>
                </li>
                <li>
                  <span class="da-kpi-finalizados__lbl">Resolvidos pela equipe</span>
                  <span class="da-kpi-finalizados__num">{{ detalheSeguro.resolvidosPelaEquipe }}</span>
                </li>
                <li>
                  <span class="da-kpi-finalizados__lbl">Resolvidos pelo bot</span>
                  <span class="da-kpi-finalizados__num">{{ detalheSeguro.resolvidosPeloBot }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="da-kpis__grid da-kpis__grid--rest">
        <article
          v-for="(card, idx) in cardsRest"
          :key="card.id || `rest-${idx}`"
          class="da-kpi-card da-kpi-card--enter"
          :style="{ animationDelay: `${(idx + 2) * 45}ms` }"
        >
          <span class="da-kpi-card__label">{{ card.label }}</span>
          <p class="da-kpi-card__value">
            {{ card.value }}
          </p>
          <p
            v-if="card.subtitle"
            class="da-kpi-card__sub"
          >
            {{ card.subtitle }}
          </p>
          <p
            v-if="card.delta != null && card.delta !== ''"
            class="da-kpi-card__delta"
            :class="{
              'da-kpi-card__delta--up': card.deltaPositive === true,
              'da-kpi-card__delta--down': card.deltaPositive === false,
              'da-kpi-card__delta--neu': card.deltaPositive == null,
            }"
          >
            {{ card.delta }}
          </p>
        </article>
      </div>
    </template>
  </section>
</template>

<script>
export default {
  name: 'KpisResumoAtendentes',
  props: {
    cards: {
      type: Array,
      default: () => [],
    },
    finalizadosDetalhe: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      finalizadosExpandido: false,
    }
  },
  computed: {
    cardsTop() {
      return (this.cards || []).filter(c => c.rowTop)
    },
    cardConversas() {
      return this.cardsTop.find(c => c.featured) || null
    },
    cardFinalizados() {
      return this.cardsTop.find(c => c.clickable) || null
    },
    cardsRest() {
      return (this.cards || []).filter(c => !c.rowTop)
    },
    detalheSeguro() {
      const d = this.finalizadosDetalhe || {}
      return {
        semAtendenteVinculado: Number(d.semAtendenteVinculado) || 0,
        resolvidosPelaEquipe: Number(d.resolvidosPelaEquipe) || 0,
        resolvidosPeloBot: Number(d.resolvidosPeloBot) || 0,
      }
    },
  },
  watch: {
    loading(val) {
      if (val) this.finalizadosExpandido = false
    },
    cards: {
      deep: true,
      handler() {
        this.finalizadosExpandido = false
      },
    },
  },
  methods: {
    alternarFinalizados() {
      this.finalizadosExpandido = !this.finalizadosExpandido
    },
  },
}
</script>

<style scoped>
.da-kpis {
  margin-bottom: 32px;
}

.da-kpis__title {
  margin: 0 0 0.35rem;
  font-size: clamp(1.25rem, 2.5vw, 1.65rem);
  font-weight: 800;
  color: #3c315b;
  letter-spacing: -0.02em;
  font-family: 'Plus Jakarta Sans', 'Sora', system-ui, sans-serif;
}

.da-kpis__lead {
  margin: 0 0 1.25rem;
  font-size: 0.92rem;
  color: #6f6787;
  max-width: 640px;
  line-height: 1.5;
}

.da-kpis__loading {
  display: flex;
  justify-content: center;
  padding: 2.5rem;
  color: #6f35d0;
}

.da-kpis__top-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
  margin-bottom: 18px;
}

@media (max-width: 640px) {
  .da-kpis__top-row {
    grid-template-columns: 1fr;
  }
}

.da-kpis__grid--rest {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 18px;
}

@media (min-width: 1100px) {
  .da-kpis__grid--rest {
    grid-template-columns: repeat(3, 1fr);
  }
}

.da-kpi-card {
  background: #fff;
  border-radius: 20px;
  padding: 1.25rem 1.35rem;
  border: 1px solid #e9dff5;
  box-shadow: 0 10px 30px rgba(80, 45, 120, 0.08);
  transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease;
  position: relative;
  overflow: hidden;
}

.da-kpi-card--clickable {
  cursor: pointer;
}

.da-kpi-card--clickable:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 30px rgba(80, 45, 120, 0.12);
  border-color: #d4c4ec;
}

.da-kpi-card--clickable:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(111, 53, 208, 0.35);
}

.da-kpi-card__chev {
  position: absolute;
  top: 1rem;
  right: 1rem;
  color: #9b8fb8;
  transition: transform 0.25s ease, color 0.2s ease;
}

.da-kpi-card--expanded .da-kpi-card__chev {
  transform: rotate(180deg);
  color: #6f35d0;
}

.da-kpi-finalizados-wrap {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
  background: #fff;
  border-radius: 20px;
  border: 1px solid #e9dff5;
  box-shadow: 0 10px 30px rgba(80, 45, 120, 0.08);
  overflow: hidden;
  transition: box-shadow 0.22s ease, border-color 0.22s ease;
}

.da-kpi-finalizados-wrap:hover {
  box-shadow: 0 14px 30px rgba(80, 45, 120, 0.1);
  border-color: #e0d4ef;
}

.da-kpi-finalizados-wrap .da-kpi-card {
  border: none;
  border-radius: 0;
  box-shadow: none;
}

.da-kpi-finalizados-wrap .da-kpi-card--clickable:hover {
  transform: none;
  box-shadow: none;
}

.da-kpi-finalizados-wrap .da-kpi-card--clickable:focus {
  box-shadow: inset 0 0 0 2px rgba(111, 53, 208, 0.35);
}

.da-kpi-finalizados__panel {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.32s ease;
}

.da-kpi-finalizados__panel--open {
  grid-template-rows: 1fr;
}

.da-kpi-finalizados__inner {
  overflow: hidden;
  min-height: 0;
}

.da-kpi-finalizados__panel--open .da-kpi-finalizados__inner {
  border-top: 1px solid #ede8f5;
  background: #fbf9fe;
}

.da-kpi-finalizados__lead {
  margin: 0;
  padding: 0.65rem 1.35rem 0;
  font-size: 0.82rem;
  color: #6f6787;
  line-height: 1.4;
}

.da-kpi-finalizados__list {
  list-style: none;
  margin: 0;
  padding: 0.35rem 1.35rem 1rem;
}

.da-kpi-finalizados__list li {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 1rem;
  padding: 0.55rem 0;
  border-bottom: 1px solid #ede8f5;
  font-size: 0.88rem;
}

.da-kpi-finalizados__list li:last-child {
  border-bottom: none;
}

.da-kpi-finalizados__lbl {
  color: #3c315b;
  font-weight: 600;
}

.da-kpi-finalizados__num {
  font-weight: 800;
  color: #5e2bb8;
  font-variant-numeric: tabular-nums;
}

.da-kpi-card--enter {
  animation: daKpiIn 0.5s ease both;
}

@keyframes daKpiIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.da-kpi-card:not(.da-kpi-card--clickable):hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 30px rgba(80, 45, 120, 0.1);
  border-color: #e0d4ef;
}

.da-kpi-card--featured {
  background: linear-gradient(145deg, #6f35d0 0%, #8a46e8 55%, #c94bb8 100%);
  border: none;
  color: #fff;
  box-shadow: 0 14px 36px rgba(111, 53, 208, 0.35);
}

.da-kpi-card--featured .da-kpi-card__label {
  color: rgba(255, 255, 255, 0.88);
}

.da-kpi-card--featured .da-kpi-card__value {
  color: #fff;
}

.da-kpi-card--featured .da-kpi-card__sub {
  color: rgba(255, 255, 255, 0.82);
}

.da-kpi-card--featured .da-kpi-card__delta {
  color: rgba(255, 255, 255, 0.95);
}

.da-kpi-card__icon {
  position: absolute;
  top: 1rem;
  right: 1rem;
  opacity: 0.35;
  color: #fff;
}

.da-kpi-card__label {
  display: block;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #7a7294;
  margin-bottom: 0.5rem;
}

.da-kpi-card__value {
  margin: 0;
  font-size: clamp(1.65rem, 3vw, 2.1rem);
  font-weight: 800;
  color: #5e2bb8;
  letter-spacing: -0.03em;
  line-height: 1.1;
  font-family: 'Plus Jakarta Sans', 'Sora', system-ui, sans-serif;
}

.da-kpi-card__sub {
  margin: 0.45rem 0 0;
  font-size: 0.82rem;
  color: #8c84a3;
  line-height: 1.35;
}

.da-kpi-card__delta {
  margin: 0.55rem 0 0;
  font-size: 0.78rem;
  font-weight: 700;
}

.da-kpi-card__delta--up {
  color: #25c38e;
}

.da-kpi-card__delta--down {
  color: #f16a6a;
}

.da-kpi-card--featured .da-kpi-card__delta--up,
.da-kpi-card--featured .da-kpi-card__delta--down,
.da-kpi-card--featured .da-kpi-card__delta--neu {
  color: rgba(255, 255, 255, 0.92);
}

.da-kpi-card__delta--neu {
  color: #8c84a3;
}
</style>
